import React from 'react';
import AdminModal from 'components/admin/AdminModal';
import Button from 'components/Button';

interface ConfirmDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  loading = false,
}) => {
  return (
    <AdminModal
      isOpen={isOpen}
      onClose={onClose}
      title="Confirm Deletion"
      size="sm"
    >
      <div className="flex flex-col items-center justify-center p-4 text-center">
        <p className="mb-6 text-gray-600">
          Are you sure you want to delete this Entry?
        </p>
        <div className="flex gap-4">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={loading}
            className="w-24"
          >
            No
          </Button>
          <Button
            variant="primary"
            onClick={onConfirm}
            loading={loading}
            className="w-24 bg-red-600 hover:bg-red-700 border-red-600"
          >
            Yes
          </Button>
        </div>
      </div>
    </AdminModal>
  );
};

export default ConfirmDeleteModal;
